import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checkpoint-answer-view',
    templateUrl: './checkpoint-answer-view.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkpoint-answer-view.component.scss'],
    standalone: false,
})
export class FiChecklistCheckpointAnswerViewComponent {
    @Input() checkpoint;
    @Input() checklist;
    @Input() checklistViewer;
    @Input() checkpointAnswer;
}
